import React from 'react';
import Helmet from 'react-helmet';
import CopyToClipboard from 'react-copy-to-clipboard';

import Certificate from './Certificate';
import PrintButton from './PrintButton';
import { safeCredentials, handleErrors } from '../../utils/fetchHelpers';
import conversionTracker from '../../utils/conversionTracker';

import './CertificatePage.scss';

class CertificatePage extends React.Component {
  state = {
    componentReadyToRender: false,
    enrollment: null,
    copied: false,
  };

  componentDidMount() {
    fetch(`/api/v2/profiles/${this.props.server_data.params.username}/certificates/${this.props.server_data.params.symbol}`, safeCredentials({}))
    .then(handleErrors)
    .then((res) => {
      this.setState({ enrollment: res.data }, () => {
        this.setState({ componentReadyToRender: true });
      });

      conversionTracker(window, 'ViewContent', {
        content_category: 'certificates',
        content_name: `${res.data.relationships.profile.data.attributes.first_name} ${res.data.relationships.profile.data.attributes.last_name} (${res.data.relationships.enrollable.data.attributes.long_name})`,
      });
    });
  }

  onCopiedLink = () => {
    this.setState({ copied: true }, () => {
      setTimeout(() => { this.setState({ copied: false }); }, 1000);
    });
  }

  render() {
    if (this.state.componentReadyToRender) {
      const profile = this.state.enrollment.relationships.profile.data.attributes;
      const enrollable = this.state.enrollment.relationships.enrollable.data.attributes;
      const enrollment = this.state.enrollment;

      return (
        <div className='wrapper bg-secondary'>
          <Helmet title={`Certificate for ${profile.first_name} ${profile.last_name || ''}`} />
          <div className="bg-light p-3 text-center">
            <CopyToClipboard
              text={`${window.location}`}
              onCopy={() => this.onCopiedLink()}
            >
              <button className="btn btn-primary boxshadowLight mr-2">
                {this.state.copied ? 'Copied' : 'Share'}
              </button>
            </CopyToClipboard>
            <p className='d-inline-block mr-2 mb-0 align-top border rounded overflow-auto link'><span>{`${window.location}`}</span></p>
            <PrintButton id={"certificate"} />
          </div>
          <div id="pdfpreview" className='pdfpreview bg-secondary d-none d-md-block'>
          </div>
          <div className="container">
            <div className="row">
              <div className='content col overflow-auto'>
                <Certificate profile={profile} enrollable={enrollable} enrollment={enrollment} />
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}

export default CertificatePage;
